import { Column } from 'primereact/column'
import React, { useEffect } from 'react'
import { tableCellCentered } from '../../../../../assets/js/styles'
import { CustomCheckbox, CustomDataTableHeader, CustomPanel } from '../../../../../components'
import { DataTable } from 'primereact/datatable'
import useRegrasFaturamento, { LOAD_MESSAGE } from './RegrasFaturamentoHook'
import RegrasFaturamentoModal, { TIPO_REGRA } from './RegrasFaturamentoModal'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../../store/actions/system.actions'

function RegrasFaturamento({ history, selectedTp, dispatch }) {
  const { state, localDispatch } = useRegrasFaturamento()

  useEffect(() => {
    localDispatch.onInit(selectedTp)
  }, [selectedTp])

  useEffect(() => {
    switch (state.loadingMessage) {
      case LOAD_MESSAGE.NONE:
        dispatch(hideLoadingBox())
        break

      case LOAD_MESSAGE.LOADING:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        localDispatch.loadRegrasFaturamento(selectedTp)
        break

      default:
        break
    }
  }, [state.loadingMessage])

  useEffect(() => {
    if (state.errorMessage) {
      dispatch(showMessageBox(null, state.errorMessage))
      localDispatch.resetErrorMessage()
    }
  }, [state.errorMessage])

  return (
    <div style={{ marginTop: 20 }}>
      <CustomPanel onNovo={() => localDispatch.onBtnNovo(selectedTp)} onVoltar={history.goBack}>
        <div className="p-grid">
          <div className="p-col-12">
            <DataTable
              value={state.regrasFaturamento}
              header={
                <CustomDataTableHeader
                  onChange={value => localDispatch.onGlobalFilterChange(value)}
                />
              }
              emptyMessage={'Não existe regras de faturamento cadastradas . . .'}
              globalFilter={state.globalFilter}
              paginator={true}
              rows={10}
              selectionMode="single"
              onSelectionChange={e => localDispatch.onDataTableItemClicked(e.value)}
            >
              <Column field="id" header="Código" style={tableCellCentered(80)} />
              <Column field="name" header="Nome" />
              <Column
                field="type"
                header="Tipo"
                body={item => {
                  const tipoEncontrado = TIPO_REGRA.find(tipo => tipo.id === item.type)
                  return tipoEncontrado ? tipoEncontrado.nome : ''
                }}
              />
              <Column
                field="actived"
                header="Ativo"
                style={tableCellCentered(80)}
                body={regrasFaturamento => (
                  <CustomCheckbox onChange={() => {}} checked={regrasFaturamento.actived} />
                )}
              />
            </DataTable>
          </div>
        </div>
      </CustomPanel>
      <RegrasFaturamentoModal
        show={state.modal.show}
        onModalClose={localDispatch.onModalClose}
        onModalSave={localDispatch.onModalSave}
        data={state.modal.data}
      />
    </div>
  )
}

const mapStateToProps = ({ system: { selectedTp } }) => ({ selectedTp })
export default connect(mapStateToProps)(withRouter(RegrasFaturamento))
